export default {"src":"/_next/static/media/Ellipse 11.85acc7c5.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};